import React from "react";
import FDropdown from "@components/FDropdown";

interface ContentRoundSelectorProps {
  rounds: any[];
  selectedRound: number;
  onRoundChange: (value: number) => void;
}

const ContentRoundSelector: React.FC<ContentRoundSelectorProps> = ({
  rounds,
  selectedRound,
  onRoundChange,
}) => (
  <FDropdown
    options={rounds.map((round, index) => ({
      value: index,
      label: `Round ${round.stage}`,
    }))}
    selectedValue={selectedRound}
    onChange={onRoundChange}
    width="180px"
  />
);

export default ContentRoundSelector;
